import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.css']
})
export class IconComponent implements ICellRendererAngularComp {
  params: ICellRendererParams;
  agRowData: any;
  @Input() status = false;

  constructor() {}

  get iconStatus() {
    return this.params.value || false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.agRowData = params.node.data;
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    return true;
  }
}
